<template>
  <el-card class="user-nav-panel">
    <div slot="header" class="clearfix">
      <span class="panel-header">个人中心</span>
    </div>

    <el-menu router :default-active="activeKey">
      <el-menu-item index="/user/account/info">
        <span slot="title">账户信息</span>
      </el-menu-item>
      <el-menu-item index="/user/address/list" v-if="employeeLevel !==85">
        <span slot="title">默认地址管理</span>
      </el-menu-item>
      <!-- <el-menu-item index="/user/custom-address/list">
        <span slot="title">自用地址管理</span>
      </el-menu-item>-->
      <el-menu-item index="/user/notice/list">
        <span slot="title">公告通知</span>
      </el-menu-item>
      <el-menu-item index="/user/faq">
        <span slot="title">常见问题</span>
      </el-menu-item>
      <el-menu-item index="/user/contact">
        <span slot="title">联系客服</span>
      </el-menu-item>
      <!-- <el-menu-item v-if="isRTM" index="/user/client/list">
        <span slot="title">人员管理</span>
      </el-menu-item> -->
      <el-menu-item v-if="userInfo.employeeLevel > 40" index="/user/download">
        <span slot="title">文件下载</span>
      </el-menu-item>
    </el-menu>
    <!-- <div class="user-manual-block">
      <a :href="templateFile" target="_blank">
        <div class="manual-cover">
          <img src="../../../assets/images/user-manual.png" />
        </div>
        <div class="manual-name">尊享先锋订单平台系统操作手册</div>
        <div class="manual-sub-name">(PDF文件)</div>
      </a>
    </div>-->
  </el-card>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'user-left-panel',
  data () {
    return {
      employeeLevel: '',

      activeKey: '',
      dialogVisible: false,
      entityId: '',
      entityList: [],
      templateFile: require('@/assets/files/ABI_POCM_1227.pdf'),
      isRTM: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  watch: {
    '$route.path' (val) {
      this.activeKey = val
    }
  },
  created () {
    this.employeeLevel = this.userInfo.employeeLevel

    this.activeKey = this.$route.path
    if (this.activeKey.toLowerCase() === '/user/index') {
      this.activeKey = '/user/account/info'
    }
    this.isRTM = this.userInfo.employeeLevel === 50
  }
}
</script>

<style lang="scss" scoped>
.user-nav-panel {
  width: 80%;
  min-height: 750px;
  margin: 0 auto;
  background: $base-white;

  ::v-deep .el-card__body {
    padding: 0;
  }

  .panel-header {
    font-size: 16px;
    font-weight: 700;
  }
  ::v-deep .el-menu {
    border-right: 0;
  }
  ::v-deep .el-menu-item {
    border-bottom: 1px solid $base-grey5;
  }

  ::v-deep .el-menu-item.is-active {
    color: $base-red;
  }
}
</style>
